import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Heart, MessageCircle, Bookmark, Share2, Image as ImageIcon } from 'lucide-react';
import { useState } from 'react';
import OceanBackground from '@/components/background/OceanBackground';

const feeds = [
  { id: 1, user: '旅行者小王', time: '2小时前', content: '终于来到了心心念念的大理,洱海真的太美了!', images: ['dali,lake', 'dali,ancient'], type: '动态', likes: 45, comments: 12 },
  { id: 2, user: '摄影师李', time: '5小时前', content: '分享一组川西的照片,每一张都是壁纸级别。', images: ['sichuan,mountain'], type: '游记', likes: 128, comments: 34 },
  { id: 3, user: '背包客阿杰', time: '昨天', content: '今天走了三万步,腿废了但是值得!', images: [], type: '日记', likes: 23, comments: 5 },
];

const Community = () => {
  const navigate = useNavigate();
  const [likedSet, setLikedSet] = useState(new Set());

  const toggleLike = (id) => {
    const next = new Set(likedSet);
    if (next.has(id)) next.delete(id); else next.add(id);
    setLikedSet(next);
  };

  return (<div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, #041426 0%, #061A2C 50%, #041426 100%)' }}>
      <Navbar />
      <OceanBackground />
      <div className="max-w-2xl mx-auto px-4 md:px-6 pt-28 pb-20 relative z-10">
        <h1 className="text-3xl font-bold text-text-primary mb-4">旅行社区</h1>
        <Tabs defaultValue="推荐" className="mb-6">
          <TabsList className="rounded-btn p-1 shadow-card" style={{ background: 'rgba(8, 21, 38, 0.55)', border: '1px solid rgba(143,169,192,0.12)' }}>
            {['推荐', '最新', '关注'].map((t) => <TabsTrigger key={t} value={t} className="rounded-btn px-4 data-[state=active]:bg-primary data-[state=active]:text-white">{t}</TabsTrigger>)}
          </TabsList></Tabs>

        <Card className="border-0 shadow-card rounded-card mb-6 cursor-pointer" onClick={() => navigate('/travelogues/new')} style={{ background: 'rgba(8, 21, 38, 0.55)', backdropFilter: 'blur(12px)', border: '1px solid rgba(143,169,192,0.12)' }}>
          <CardContent className="p-4 flex items-center gap-3">
            <Avatar className="w-10 h-10"><AvatarFallback className="bg-primary-light text-primary">我</AvatarFallback></Avatar>
            <div className="flex-1 bg-bg-secondary rounded-btn px-4 py-2 text-sm text-text-tertiary">分享你的旅途...</div>
          </CardContent>
        </Card>

        <div className="space-y-5">
          {feeds.map((f) => (
            <Card key={f.id} className="border-0 shadow-card rounded-card" style={{ background: 'rgba(8, 21, 38, 0.55)', backdropFilter: 'blur(12px)', border: '1px solid rgba(143,169,192,0.12)' }}>
              <CardContent className="p-4">
                <div className="flex items-center gap-3 mb-3">
                  <Avatar className="w-10 h-10"><AvatarFallback className="bg-bg-secondary text-text-secondary">{f.user[0]}</AvatarFallback></Avatar>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-text-primary">{f.user}</p>
                    <p className="text-xs text-text-tertiary">{f.time}</p>
                  </div>{f.type !== '动态' && <Badge className="bg-primary-light text-primary rounded-full text-[10px]">{f.type}</Badge>}
                </div>
                <p className="text-sm text-text-primary mb-3 leading-relaxed">{f.content}</p>
                {f.images.length > 0 && (
                  <div className={`grid gap-2 mb-3 ${f.images.length === 1 ? 'grid-cols-1' : f.images.length === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
                    {f.images.map((img, i) => (
                      <div key={i} className="aspect-square bg-bg-secondary rounded-smwidget overflow-hidden">
                        <img src={`https://picsum.photos/seed/${img}/400/400`} alt="" className="w-full h-full mx-auto object-cover" />
                      </div>
                    ))}
                  </div>
                )}
                <div className="flex items-center gap-6 text-text-tertiary text-xs">
                  <button onClick={() => toggleLike(f.id)} className={`flex items-center gap-1 transition-all ${likedSet.has(f.id) ? 'text-danger scale-110' : ''}`}><Heart className={`w-4 h-4 ${likedSet.has(f.id) ? 'fill-danger' : ''}`} /> {f.likes + (likedSet.has(f.id) ? 1 : 0)}</button>
                  <button className="flex items-center gap-1"><MessageCircle className="w-4 h-4" /> {f.comments}</button>
                  <button className="flex items-center gap-1"><Bookmark className="w-4 h-4" /></button>
                  <button className="flex items-center gap-1"><Share2 className="w-4 h-4" /></button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Community;
